import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import MainCourses from './components/MainCourses';
import AdditionalServices from './components/AdditionalServices';
import ContractBenefits from './components/ContractBenefits';
import PricingSection from './components/PricingSection';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <ServicesHero />
        <MainCourses />
        <AdditionalServices />
        <ContractBenefits />
        <PricingSection />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
